var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bbf27cc30fb29c48f68c4e3099ed232f26a8c03f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["joyride-frontend@vafo"]={id:"bbf27cc30fb29c48f68c4e3099ed232f26a8c03f"};
      